import { useEffect, useState } from "react";
import Header from "../partials/header";
import LeftSidebar from "../partials/leftSidebar";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import GeneralCard from "../sharedComponent/generalCard";
// import AuditLogIcon from "../../assets/images/audit-log.svg";
import UserIcon from "../../assets/images/users-icon.svg";
import { useNavigate } from "react-router-dom";
import { PROFILE_TYPE } from "../../helper/globalConstant";
import platformManagementIcon from "../../assets/images/platform.svg";
import { IconUsers } from '@tabler/icons-react';
import PlatformIcon from "../icons/PlatformIcon";
type Card = {
  name: "distributors" | "partners" | "technicians" | "platform" | "users";
  cardTitle: string;
  cardContent: string;
  // image?: string;
  icon?: React.ElementType
}

const AdminMain = () => {

  // partner -> technicians
  const cardPartnerData: Card[] = [
    {
      name: "technicians",
      cardTitle: "Technicians",
      cardContent:
        "Manage all technician accounts under the Partner Account. Click here to add, edit, or remove accounts and configure permissions to ensure security and control.",
      icon: IconUsers,
    },
  ];

  // distributors -> partners
  const cardDistributorData: Card[] = [
    {
      name: "partners",
      cardTitle: "Partners",
      cardContent:
        "Manage all Partner accounts under the Distributor Account. Click here to add, edit, or remove accounts and configure permissions to ensure security and control.",
      icon: IconUsers,
    },
  ];

  // admin -> distributors
  const cardAdminCardData: Card[] = [
    {
      name: "distributors",
      cardTitle: "Distributors",
      cardContent:
        "Manage all Distributor accounts under the Super Admin Account. Click here to add, edit, or remove accounts and configure permissions to ensure security and control.",
      // image: UserIcon,
         icon: IconUsers,
    },
    {
      name: "platform",
      cardTitle: "Platform Management",
      cardContent: "Setup your Platform for Public or Private Cloud.",
      icon: PlatformIcon,
    },
  ];

  const navigate = useNavigate();

  const [profileId, setProfileId] = useState<number | null>(null);

  useEffect(() => {
    const sess_user_data = localStorage.getItem("sess_user");

    if (sess_user_data != null) {
      const sess_user = JSON.parse(sess_user_data);
      setProfileId(sess_user?.userProfile?.priority || null);
    }
  }, []);

  const handleClick = (name: Card['name']) => {
    navigate(`/admin/${name}`);
  }

  return (
    <Box sx={{ display: "flex" }}>
      <Header title="Admin" />
      <LeftSidebar />
      <Box
        sx={{
          flexGrow: 1,
          p: 3,
          marginTop: 8,
          padding: "0",
        }}
      >
        <Box sx={{ margin: "20px" }} component="main">
          <Grid container spacing={2}>

            {profileId === PROFILE_TYPE.INTEGRATOR &&
              cardPartnerData.map((item: Card) => (
                <Grid size={{ xs: 12, md: 6, lg: 4 }} key={item.name}>
                  <GeneralCard data={item} handleClick={handleClick} cardContainerStyle={{ height: "167px" }} />
                </Grid>
              ))}

            {profileId === PROFILE_TYPE.DISTRIBUTOR &&
              cardDistributorData.map((item: Card) => (
                <Grid size={{ xs: 12, md: 6, lg: 4 }} key={item.name}>
                  <GeneralCard data={item} handleClick={handleClick} cardContainerStyle={{ height: "167px" }} />
                </Grid>
              ))}

            {profileId === PROFILE_TYPE.SUPER_ADMIN &&
              cardAdminCardData.map((item: Card) => (
                <Grid size={{ xs: 12, md: 6, lg: 4 }} key={item.name}>
                  <GeneralCard data={item} handleClick={handleClick} cardContainerStyle={{ height: "167px" }} />
                </Grid>
              ))}

          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default AdminMain;
